import { Mail, Phone, Instagram, Facebook, MessageCircle } from "lucide-react";
import { LogoLockup } from "@/components/Logo";
import { site, waLink } from "@/lib/site";
import { track } from "@/lib/analytics";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      id="contato"
      data-testid="footer"
      className="relative bg-[#0e3b21] text-white pt-16 pb-8"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="grid md:grid-cols-3 gap-10">
          <div>
            <LogoLockup tone="light" size={40} />
            <p className="mt-5 text-sm text-white/70 leading-relaxed max-w-xs">
              Indústria e comércio de produtos químicos — soluções técnicas
              para quem produz de verdade.
            </p>
            <div className="mt-5 flex items-center gap-3">
              <a
                data-testid="footer-instagram"
                href={site.socials.instagram}
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => track("social_click", { network: "instagram" })}
                aria-label="Instagram Serequímica"
                className="h-10 w-10 rounded-full border border-white/15 flex items-center justify-center hover:bg-[#c9a24c] hover:text-[#0e3b21] hover:border-[#c9a24c] transition-all"
              >
                <Instagram size={18} />
              </a>
              <a
                data-testid="footer-facebook"
                href={site.socials.facebook}
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => track("social_click", { network: "facebook" })}
                aria-label="Facebook Serequímica"
                className="h-10 w-10 rounded-full border border-white/15 flex items-center justify-center hover:bg-[#c9a24c] hover:text-[#0e3b21] hover:border-[#c9a24c] transition-all"
              >
                <Facebook size={18} />
              </a>
              <a
                data-testid="footer-whatsapp"
                href={waLink()}
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => track("whatsapp_click", { source: "footer_icon" })}
                aria-label="WhatsApp Serequímica"
                className="h-10 w-10 rounded-full bg-[#25D366] flex items-center justify-center hover:bg-[#1ebe57] transition-all"
              >
                <MessageCircle size={18} />
              </a>
            </div>
          </div>

          <div>
            <div className="text-[#c9a24c] uppercase tracking-[0.2em] text-xs font-semibold">
              Contato
            </div>
            <ul className="mt-5 space-y-3 text-sm">
              <li>
                <a
                  data-testid="footer-wa-link"
                  href={waLink()}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() => track("whatsapp_click", { source: "footer_link" })}
                  className="flex items-center gap-3 text-white/85 hover:text-[#c9a24c] transition-colors"
                >
                  <Phone size={16} className="text-[#c9a24c]" />
                  {site.whatsappDisplay} <span className="text-[#25D366] text-xs">· WhatsApp</span>
                </a>
              </li>
              <li>
                <a
                  data-testid="footer-email"
                  href={`mailto:${site.email}`}
                  className="flex items-center gap-3 text-white/85 hover:text-[#c9a24c] transition-colors"
                >
                  <Mail size={16} className="text-[#c9a24c]" />
                  {site.email}
                </a>
              </li>
            </ul>
          </div>

          <div>
            <div className="text-[#c9a24c] uppercase tracking-[0.2em] text-xs font-semibold">
              Catálogos
            </div>
            <ul className="mt-5 space-y-3 text-sm">
              {site.catalogs.map((c) => (
                <li key={c.id}>
                  <a
                    data-testid={`footer-catalog-${c.id}`}
                    href={c.pdf}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={() => track("catalog_download", { catalog: c.id, source: "footer" })}
                    className="text-white/85 hover:text-[#c9a24c] transition-colors"
                  >
                    Catálogo {c.title}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-white/50">
          <div>
            © {year} Serequímica. Todos os direitos reservados.
          </div>
          <div className="tracking-[0.25em] uppercase">
            Ciência · Tecnologia · Resultados
          </div>
        </div>
      </div>
    </footer>
  );
}
